import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import BgImage from "../../images/practiceArea/agreement.jpeg";

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get("https://backend.lawberonlegals.com/api/articles");
        setArticles(response.data);
      } catch (err) {
        setError("Failed to load articles, check your internet connection and refresh the page.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div>
      <section className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}>
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Article & News</h1>
          <p className="text-lg text-white md:text-l mb-6">
            Stay Informed: Explore the Latest Articles and News at Lawberon Legals & Co.
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link to="/about" className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl shadow-lg transition duration-300">
              Learn More
            </Link>
            <Link to="/book" className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-900 text-white font-semibold py-2 px-4 rounded-xl shadow-lg transition duration-300">
              Speak with a consultant
            </Link>
          </div>
        </div>
      </section>

      <section className="px-[6%] my-6">
        <h2 className="text-2xl font-bold text-center mb-6">Latest Articles</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {loading && (
            <p className="text-center text-lg font-semibold">Loading articles...</p>
          )}
          {error && (
            <p className="text-center text-red-500">{error}</p>
          )}
          {articles.map((article) => (
            <div key={article._id} className="bg-white shadow-lg rounded-lg overflow-hidden">
              <img
                src={article.coverImage || "https://via.placeholder.com/300"}
                alt={article.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <Link to={`/insights/${article.title.toLowerCase().replace(/\s+/g, '-')}`}>
                  <h3 className="text-lg font-semibold hover:text-red-500">{article.title}</h3>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Articles;
